export type ModalSwitchInputProps = {
  label: string;
  checked: boolean;
  handleChange: (isChecked: boolean) => void;
  disabled?: boolean;
};

export { default as ModalSwitchInput } from './ModalSwitchInput';
